import styled from '@emotion/styled';
import LogoSvg from '../../../../../assets/clt-logo.svg';

export const Logo = styled(LogoSvg)`
	display: block;
`;
